/* ============================================================
   Flower Station Dubai — preservation-consult.js
   Multi-step consultation wizard controller.
   Vanilla IIFE (no deps). Pairs with sections/preservation-consult.liquid
   and assets/component-consultation.css.

   Flow: step nav + per-step validation → collect answers → submit.
   Submit calls the Cloudflare Worker (data-api):
     1. POST /api/consult/init      → { projectId, uploads:[{key,url}] }
     2. PUT each photo → presigned R2 url
     3. POST /api/consult/complete  → { ok:true }
   With data-api blank, runs in preview/demo mode (no network, fake Project ID).
   ============================================================ */
(function () {
  var root = document.querySelector('[data-pconsult]');
  if (!root) return;

  var form     = root.querySelector('[data-pc-form]');
  var panels   = Array.prototype.slice.call(root.querySelectorAll('.pconsult__panel'));
  var progress = Array.prototype.slice.call(root.querySelectorAll('[data-progress-step]'));
  var bar      = root.querySelector('[data-bar]');
  var curNum   = root.querySelector('[data-cur]');
  var curLabel = root.querySelector('[data-cur-label]');
  var backBtn  = root.querySelector('[data-back]');
  var nextBtn  = root.querySelector('[data-next]');
  var submitBtn= root.querySelector('[data-submit]');
  var successEl= root.querySelector('[data-success]');
  var body     = root.querySelector('.pconsult__body');
  var nav      = root.querySelector('.pconsult__nav');

  var API      = (root.getAttribute('data-api') || '').replace(/\/+$/, '');
  var MIN      = parseInt(root.getAttribute('data-min'), 10); if (isNaN(MIN)) MIN = 3;
  var MAX      = parseInt(root.getAttribute('data-max'), 10); if (isNaN(MAX)) MAX = 10;
  var TS_KEY   = root.getAttribute('data-turnstile') || '';
  var MAX_BYTES = 10 * 1024 * 1024;
  var OK_TYPES = /^image\/(jpeg|png|heic|heif)$/i;
  var OK_EXT   = /\.(jpe?g|png|heic|heif)$/i;

  var total   = panels.length;
  var current = 1;
  var option  = '';          // selected preservation option
  var files   = [];          // [{ id, file, url }]
  var seq     = 0;
  var tsWidget = null;

  /* ── helpers ── */
  function toast(msg, kind) {
    if (window.FSToast && typeof window.FSToast.show === 'function') window.FSToast.show(msg, kind || 'error');
  }
  function showErr(name, msg) {
    var el = root.querySelector('[data-error="' + name + '"]');
    if (!el) return;
    if (msg) el.textContent = msg;
    el.hidden = false;
  }
  function hideErr(name) {
    var el = root.querySelector('[data-error="' + name + '"]');
    if (el) el.hidden = true;
  }
  function panelFor(step) { return panels[step - 1]; }

  /* ── progress ── */
  function paint() {
    progress.forEach(function (li) {
      var n = parseInt(li.getAttribute('data-progress-step'), 10);
      li.classList.toggle('is-done', n < current);
      li.classList.toggle('is-active', n === current);
    });
    if (bar) bar.style.width = Math.round((current / total) * 100) + '%';
    if (curNum) curNum.textContent = current;
    if (curLabel) {
      var t = panelFor(current).querySelector('.pconsult__step-title');
      curLabel.textContent = t ? t.textContent.trim() : '';
    }
    if (backBtn) backBtn.hidden = current === 1;
    var last = current === total;
    if (nextBtn) nextBtn.hidden = last;
    if (submitBtn) submitBtn.hidden = !last;
  }

  function goTo(step) {
    current = Math.max(1, Math.min(total, step));
    panels.forEach(function (p, i) { p.classList.toggle('is-active', i === current - 1); });
    paint();
    if (current === total) mountTurnstile();
    // Bring the card top into view on step change (not on first paint).
    if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // Focus the first control of the new step for keyboard users.
    var focusable = panelFor(current).querySelector('select,input,textarea,button,[tabindex]');
    if (focusable) { try { focusable.focus({ preventScroll: true }); } catch (e) { focusable.focus(); } }
  }

  /* ── Step 1: option selection ── */
  function condsFor(opt) {
    if (opt === 'both') return ['resin', 'frame'];
    if (/resin/i.test(opt)) return ['resin'];
    if (/shadow|frame|box/i.test(opt)) return ['frame'];
    return ['resin', 'frame'];
  }
  function applyConds() {
    var show = condsFor(option);
    root.querySelectorAll('[data-cond]').forEach(function (el) {
      el.hidden = show.indexOf(el.getAttribute('data-cond')) === -1;
    });
  }
  root.querySelectorAll('[data-option]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      option = btn.getAttribute('data-option');
      root.querySelectorAll('[data-option]').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      hideErr('option');
      applyConds();
    });
  });

  /* ── Step 3: option pills ── */
  root.querySelectorAll('[data-pills]').forEach(function (group) {
    var multi = group.hasAttribute('data-multi');
    group.addEventListener('click', function (e) {
      var pill = e.target.closest('.opt-pill');
      if (!pill) return;
      if (multi) {
        var on = pill.classList.toggle('is-active');
        pill.setAttribute('aria-pressed', on ? 'true' : 'false');
      } else {
        group.querySelectorAll('.opt-pill').forEach(function (p) {
          var on = p === pill;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
    });
  });
  /* ── Step 3: selectable card groups (resin blocks/trays) — multi-select ── */
  root.querySelectorAll('[data-select-group]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var card = e.target.closest('.rb-card--select');
      if (!card || !group.contains(card)) return;
      var on = card.classList.toggle('is-selected');
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  });
  function collectSelectGroups(data) {
    root.querySelectorAll('[data-select-group]').forEach(function (group) {
      var name = group.getAttribute('data-select-group');
      var items = [];
      group.querySelectorAll('.rb-card--select.is-selected').forEach(function (b) {
        items.push({
          key: b.getAttribute('data-value'),
          label: b.getAttribute('data-label'),
          price: b.getAttribute('data-price') || ''
        });
      });
      data[name] = items;
    });
  }

  function collectPills(group) {
    var vals = [];
    group.querySelectorAll('.opt-pill.is-active').forEach(function (p) { vals.push(p.getAttribute('data-value')); });
    return vals;
  }

  /* ── Step 4: uploader ── */
  var dropzone = root.querySelector('[data-dropzone]');
  var fileInput = root.querySelector('[data-file]');
  var thumbs = root.querySelector('[data-thumbs]');
  var countRow = root.querySelector('[data-count-row]');
  var countEl = root.querySelector('[data-count]');
  var countHint = root.querySelector('[data-count-hint]');

  function validFile(f) {
    var t = (f.type || '').toLowerCase();
    // Accept real image types only (JPG/PNG/HEIC). Allow the extension fallback only when
    // the browser reports no type (HEIC often has none) — this rejects videos and other files.
    var accepted = OK_TYPES.test(t) || (t === '' && OK_EXT.test(f.name));
    if (!accepted) return 'unsupported';
    if (f.size > MAX_BYTES) return 'toobig';
    return '';
  }
  function isPreviewable(f) { return /^image\/(jpeg|png)$/i.test(f.type); }

  // Read a preview as a data URL. More reliable than blob: object URLs on mobile —
  // some Android browsers (e.g. Samsung Internet) fail to render blob-URL images in a
  // dynamically inserted <img>. Async, so re-render once the read completes.
  function readPreview(entry) {
    var reader = new FileReader();
    reader.onload = function (e) { entry.url = e.target.result; renderThumbs(); };
    reader.onerror = function () { entry.url = ''; renderThumbs(); };
    reader.readAsDataURL(entry.file);
  }

  function addFiles(list) {
    var arr = Array.prototype.slice.call(list);
    var rejected = 0, toobig = 0;
    for (var i = 0; i < arr.length; i++) {
      if (files.length >= MAX) { toast('You can add up to ' + MAX + ' photos.'); break; }
      var why = validFile(arr[i]);
      if (why === 'unsupported') { rejected++; continue; }
      if (why === 'toobig') { toobig++; continue; }
      var entry = { id: 'f' + (++seq), file: arr[i], url: '' };
      files.push(entry);
      if (isPreviewable(arr[i])) readPreview(entry);
    }
    if (rejected) toast(rejected + ' file(s) skipped — use JPG, PNG or HEIC.');
    if (toobig) toast(toobig + ' file(s) skipped — over 10 MB.');
    renderThumbs();
    if (files.length >= MIN) hideErr('photos');
  }

  function renderThumbs() {
    if (!thumbs) return;
    thumbs.innerHTML = '';
    files.forEach(function (entry) {
      var cell = document.createElement('div');
      cell.className = 'pc-thumb';
      if (entry.url) {
        cell.innerHTML = '<img src="' + entry.url + '" alt="">';
      } else {
        var ext = (entry.file.name.split('.').pop() || 'img').toUpperCase();
        cell.innerHTML = '<div class="pc-thumb__file"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/></svg><span>' + ext + '</span></div>';
      }
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'pc-thumb__remove';
      rm.setAttribute('aria-label', 'Remove photo');
      rm.innerHTML = '&times;';
      rm.addEventListener('click', function () { removeFile(entry.id); });
      cell.appendChild(rm);
      thumbs.appendChild(cell);
    });
    if (countRow) countRow.hidden = files.length === 0;
    if (countEl) countEl.textContent = files.length;
    if (countHint) countHint.textContent = files.length < MIN ? (MIN - files.length) + ' more needed' : 'Ready';
  }

  function removeFile(id) {
    files = files.filter(function (e) { return e.id !== id; });
    renderThumbs();
  }

  if (dropzone && fileInput) {
    dropzone.addEventListener('click', function () { fileInput.click(); });
    dropzone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); }
    });
    fileInput.addEventListener('change', function () { if (fileInput.files.length) { addFiles(fileInput.files); fileInput.value = ''; } });
    ['dragenter', 'dragover'].forEach(function (ev) {
      dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.add('is-drag'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.remove('is-drag'); });
    });
    dropzone.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files.length) addFiles(e.dataTransfer.files);
    });
  }

  /* ── Turnstile (lazy, rendered on the final step) ── */
  function mountTurnstile() {
    if (!TS_KEY) return;
    var holder = root.querySelector('[data-turnstile-holder]');
    if (!holder || tsWidget !== null) return;
    if (!window.turnstile) { setTimeout(mountTurnstile, 300); return; }
    tsWidget = window.turnstile.render(holder, { sitekey: TS_KEY });
  }
  function turnstileToken() {
    if (!TS_KEY) return '';
    if (window.turnstile && tsWidget !== null) return window.turnstile.getResponse(tsWidget) || '';
    return '';
  }
  function turnstileReset() {
    if (window.turnstile && tsWidget !== null) window.turnstile.reset(tsWidget);
  }

  /* ── validation ── */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function clearFieldErrors(panel) {
    panel.querySelectorAll('.is-error').forEach(function (el) { el.classList.remove('is-error'); });
  }
  function validate(step) {
    var panel = panelFor(step);
    clearFieldErrors(panel);

    if (step === 1) {
      if (!option) { toast('Please choose a preservation option to continue.'); return false; }
      return true;
    }
    if (step === 3) {
      var resinCond = panel.querySelector('[data-cond="resin"]');
      var frameCond = panel.querySelector('[data-cond="frame"]');
      var resinShown = resinCond && !resinCond.hidden;
      var frameShown = frameCond && !frameCond.hidden;
      function groupEmpty(cond, name) {
        var g = cond && cond.querySelector('[data-select-group="' + name + '"]');
        return !!g && g.querySelectorAll('.rb-card--select.is-selected').length === 0;
      }
      var resinMissing = resinShown && groupEmpty(resinCond, 'resin_options');
      var frameMissing = frameShown && groupEmpty(frameCond, 'frame_options');

      // "Both" selected → make clear one of each is needed.
      if (resinMissing && frameMissing) {
        toast('Please choose at least one resin option and one frame design to continue.');
        return false;
      }
      if (resinMissing) { toast('Please select at least one resin option to continue.'); return false; }
      if (frameMissing) { toast('Please select at least one frame design to continue.'); return false; }

      // Frame colour is required whenever the frame section is shown.
      if (frameShown) {
        var colorGroup = frameCond.querySelector('[data-pills][data-name="frame_color"]');
        if (colorGroup && colorGroup.querySelectorAll('.opt-pill.is-active').length === 0) {
          toast('Please choose a frame colour to continue.');
          return false;
        }
      }
      return true;
    }
    if (step === 4) {
      if (files.length < MIN) { toast('Please add at least ' + MIN + (MIN === 1 ? ' photo' : ' photos') + ' to continue.'); return false; }
      return true;
    }

    var first = null, badEmail = false, uncheck = false;
    panel.querySelectorAll('[data-required]').forEach(function (el) {
      var bad = false;
      if (el.hasAttribute('data-checkbox')) {
        bad = !el.checked;
        if (bad) uncheck = true;
      } else if (el.getAttribute('data-type') === 'email') {
        bad = !EMAIL.test((el.value || '').trim());
        if (bad && el.value.trim()) badEmail = true;
      } else {
        bad = !(el.value || '').trim();
      }
      if (bad) {
        if (el.classList.contains('field__input') || el.classList.contains('field__select')) el.classList.add('is-error');
        if (!first) first = el;
      }
    });

    if (step === total && TS_KEY && !turnstileToken()) {
      toast('Please complete the verification check.');
      return false;
    }

    if (first) {
      var msg = badEmail ? 'Please enter a valid email address.'
              : uncheck ? 'Please tick the required boxes to continue.'
              : 'Please complete the required fields.';
      toast(msg);
      try { first.focus({ preventScroll: false }); } catch (e) { first.focus(); }
      return false;
    }
    return true;
  }

  /* ── collect ── */
  // Human-readable labels for the payload (internal keys stay resin/shadowbox/both).
  // Change display names here only — the wizard logic keeps using the keys.
  var OPTION_LABELS = { resin: 'Resin', shadowbox: 'Frame', both: 'Resin & Frame' };
  function collect() {
    var data = { option: OPTION_LABELS[option] || option };
    form.querySelectorAll('[name]').forEach(function (el) {
      if (el.type === 'file') return;
      if (el.type === 'checkbox') { data[el.name] = el.checked; return; }
      data[el.name] = (el.value || '').trim();
    });
    root.querySelectorAll('[data-pills]').forEach(function (g) {
      var name = g.getAttribute('data-name');
      var vals = collectPills(g);
      data[name] = g.hasAttribute('data-multi') ? vals : (vals[0] || '');
    });
    collectSelectGroups(data);
    data.photoCount = files.length;
    data.photoNames = files.map(function (e) { return e.file.name; });
    return data;
  }

  /* ── submit ── */
  function handleRes(r) {
    return r.json().catch(function () { return {}; }).then(function (json) {
      if (!r.ok) throw new Error(json && json.error ? json.error : 'Request failed (' + r.status + ')');
      return json;
    });
  }
  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(handleRes);
  }
  function postForm(url, payload, items) {
    var fd = new FormData();
    fd.append('payload', JSON.stringify(payload));
    items.forEach(function (e) { fd.append('photos', e.file, e.file.name); });
    // Note: don't set Content-Type — the browser adds the multipart boundary.
    return fetch(url, { method: 'POST', body: fd }).then(handleRes);
  }
  function loading(on) {
    submitBtn.classList.toggle('btn--loading', on);
    submitBtn.disabled = on;
    if (backBtn) backBtn.disabled = on;
  }
  function demoId() {
    var d = new Date();
    var ymd = '' + d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2);
    // Demo/preview only — pseudo-unique suffix from the timestamp (the real Worker
    // issues an atomic FP-YYYYMMDD-NNN via a Durable Object counter).
    var seq = String(Date.now()).slice(-6);
    return 'FP-' + ymd + '-' + seq;
  }
  function finish(projectId) {
    var idEl = root.querySelector('[data-project-id]');
    if (idEl) idEl.textContent = projectId || '—';
    if (body) body.style.display = 'none';
    if (nav) nav.style.display = 'none';
    var pf = root.querySelector('.pconsult__progress'); if (pf) pf.style.display = 'none';
    var pm = root.querySelector('.pconsult__progress-mini'); if (pm) pm.style.display = 'none';
    if (successEl) successEl.classList.add('is-active');
    if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function submit() {
    if (!validate(total)) return;
    loading(true);
    var payload = collect();
    payload.turnstile = turnstileToken();

    // Preview/demo mode — no backend configured yet.
    if (!API) {
      setTimeout(function () { finish(demoId()); }, 650);
      return;
    }

    // Single POST to the Cloudflare Worker; it assigns and returns the Project ID.
    // With photos → multipart (files go to R2); without → plain JSON.
    var url = API + '/api/v1/preserve-request';
    var request = files.length ? postForm(url, payload, files) : postJSON(url, payload);
    request
      .then(function (res) { finish(res && res.projectId); })
      .catch(function (err) {
        loading(false);
        turnstileReset(); // token is single-use — issue a fresh one for the retry
        toast((err && err.message) || 'Submission failed. Please try again.');
      });
  }

  /* ── nav wiring ── */
  if (nextBtn) nextBtn.addEventListener('click', function () { if (validate(current)) goTo(current + 1); });
  if (backBtn) backBtn.addEventListener('click', function () { goTo(current - 1); });
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });

  applyConds();
  paint();
})();
